import { useEffect, useState } from 'react';
import { api } from '../api.js';
import { Button, Card, Field, Badge, Empty, Spinner, Toast } from '../ui.jsx';
import Targets from '../components/Targets.jsx';
import Requests from '../components/Requests.jsx';
import Settings from '../components/Settings.jsx';
import { ReportForm } from './Report.jsx';

const TABS = [
  ['new', '📣 تسجيل بلاغ'],
  ['targets', '🎯 الروابط المستهدفة'],
  ['requests', '📋 الطلبات'],
  ['settings', '⚙️ الإعدادات'],
];

export default function Dashboard({ go }) {
  const [tab, setTab] = useState('new');
  const [me, setMe] = useState('');
  const [toast, setToast] = useState(null);
  const [prefillTargetId, setPrefillTargetId] = useState(null);

  useEffect(() => {
    api('/api/auth/me')
      .then((d) => setMe(d.email))
      .catch(() => go('/login'));
  }, [go]);

  async function logout() {
    await api('/api/auth/logout', { method: 'POST' });
    go('/login');
  }

  function startReport(targetId) {
    setPrefillTargetId(targetId);
    setTab('new');
  }

  return (
    <div className="shell">
      <aside className="side">
        <div className="side-brand">
          <span className="side-logo">🛡️</span>
          <div>
            <b>لوحة البلاغات</b>
            <small className="muted">{me}</small>
          </div>
        </div>

        <nav className="side-nav">
          {TABS.map(([k, l]) => (
            <button
              key={k}
              className={tab === k ? 'on' : ''}
              onClick={() => {
                if (k !== 'new') setPrefillTargetId(null);
                setTab(k);
              }}
            >
              {l}
            </button>
          ))}
        </nav>

        <div className="side-foot">
          <Button variant="danger" size="sm" className="full" onClick={logout}>
            تسجيل الخروج
          </Button>
        </div>
      </aside>

      <main className="content">
        <div className="page-head">
          <h1>{TABS.find(([k]) => k === tab)?.[1]}</h1>
          <Badge tone="ok">متصل</Badge>
        </div>

        {tab === 'new' && (
          <Card title="تسجيل بلاغ داخل اللوحة">
            <ReportForm
              embedded
              notify={setToast}
              prefillTargetId={prefillTargetId}
              onDone={(_d, opts) => {
                if (opts?.goRequests) setTab('requests');
              }}
            />
          </Card>
        )}
        {tab === 'targets' && <Targets notify={setToast} onReport={startReport} />}
        {tab === 'requests' && <Requests />}
        {tab === 'settings' && <Settings notify={setToast} />}

        <p className="muted small center-text">
          نظام إدارة البلاغات — الإصدار <span id="ver">1.1</span>
        </p>
      </main>

      <Toast toast={toast} onClose={() => setToast(null)} />
    </div>
  );
}